import { render, staticRenderFns } from "./AppProducts.vue?vue&type=template&id=18d419e0&scoped=true&"
import script from "./AppProducts.vue?vue&type=script&lang=js&"
export * from "./AppProducts.vue?vue&type=script&lang=js&"
import style0 from "./AppProducts.vue?vue&type=style&index=0&id=18d419e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d419e0",
  null
  
)

export default component.exports